import { Dispatch, SetStateAction } from 'react';

export interface IFileProps {
  url?: string;
  uploadId?: string;
  fileObj?: File;
  isLoading: boolean;
}

export namespace APPLICATION_CENTER {
  export interface Error {
    getDocuments?: {
      message: string;
    };
    addDocuments?: {
      message: string;
    };
  }

  export type documentDetails = {
    upload_id: string;
    url: string;
    name: string;
    type: string;
    updated_at?: string;
  };

  export type Document = {
    file: File | undefined;
    key: string;
    url: string | undefined;
    uploadId: string | undefined;
  };

  export type applicationDocument = {
    name: string;
    label: string;
    sub_text?: string;
    file?: IFileProps;
    setFile: Dispatch<SetStateAction<IFileProps>>;
    updated_at?: string;
  };

  export enum docType {
    dba_filing = 'dba_filing',
    evidence_of_ein = 'evidence_of_ein',
    signed_w_9 = 'signed_w_9',
    article_of_incorporation = 'article_of_incorporation',
    formal_document_of_ownership = 'documentDetails',
    cannabis_license = 'cannabis_license',
    rental_agreement = 'rental_agreement',
    operating_procedures = 'operating_procedures',
    account_statement = 'account_statement',
    voided_check = 'voided_check',
    miscellaneous_doc = 'miscellaneous_doc',
  }

  export type FieldConfig = {
    id: string;
    label: string | JSX.Element;
    sub_text?: string | JSX.Element | undefined;
    name: docType;
    updated_at?: string;
    isRequired: boolean;
    shouldRender: boolean;
  };

  export type IDocumentManagement = {
    kyb_id: string;
    dba_filing?: documentDetails;
    evidence_of_ein?: documentDetails;
    signed_w_9?: documentDetails;
    article_of_incorporation?: documentDetails;
    formal_document_of_ownership?: documentDetails;
    cannabis_license?: documentDetails;
    rental_agreement?: documentDetails;
    operating_procedures?: documentDetails;
    account_statement?: documentDetails[];
    miscellaneous_doc?: documentDetails[];
    voided_check?: documentDetails;
  };

  export type ISingleDocuments = {
    dba_filing?: documentDetails;
    evidence_of_ein?: documentDetails;
    signed_w_9?: documentDetails;
    article_of_incorporation?: documentDetails;
    formal_document_of_ownership?: documentDetails;
    cannabis_license?: documentDetails;
    rental_agreement?: documentDetails;
    operating_procedures?: documentDetails;
    voided_check?: documentDetails;
  };

  export interface IApplicationCenterReducer {
    isLoading: number;
    error: Error;
    documents: IDocumentManagement;
  }
}
